<template>
  <div>
    <common-dialog
      ref="dialog"
      width="330px"
      show-save-button
      title="设置晚休留宿考勤"
      edit-title
      id-key="DeviceId"
      :data="data"
      form-label-width="110px"
      :form-rules="rules"
      :save-func="api.save"
      :get-data-func="api.info"
      @create-opened="onCreateOpened"
      @edit-opened="onEditOpened"
      :before-save="onBeforeSave"
      @close-saved="$emit('close-saved')"
      @closed="onClosed"
    >
      <template slot="form">
        <el-row>
          <el-col :span="24">
            <el-form-item label="晚休留宿考勤" prop="NightStayAttendance" class="is-required">
              <el-radio-group v-model="data.NightStayAttendance">
                <el-radio :label="1">是</el-radio>
                <el-radio :label="0">否</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
      </template>
    </common-dialog>
  </div>
</template>
<script>
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
  },
  data() {
    return {
      data: {
        NightStayAttendance: 0,
      },
      ids: [],
      isMB: this.$store.state.isMB,
      api: require("@/api/ed/class").default,
      rules: {

      },
    };
  },
  methods: {
    onCreateOpened(data) {
      this.ids = data.ids;
    },
    onEditOpened(data) {
     
    },
    onBeforeSave() {
      this.loading(true);
      this.api.setNightStayAttendance({
        NightStayAttendance: this.data.NightStayAttendance,
        Ids: this.ids
      }).then(res => {
        this.loading(false);
        if(res.Code==0) {
          this.$message.success("设置成功");
          this.close(true);
          this.$emit('close-saved');
        } else {
          this.$message.error(res.Msg);
        }
      })
      return false;
    },
    onClosed() {
      
    }
  },
};
</script>